import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Default from './layouts/Default'
import Simple from './layouts/Simple'
import VTooltip from 'v-tooltip'
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.use(VTooltip)

Vue.config.productionTip = false

Vue.component('default-layout', Default)
Vue.component('simple-layout', Simple)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
